<template>
	<div
		class="w-full min-h-screen flex flex-col justify-start items-center bg-purple-900 bg-gradient-to-b from-gray-900 via-purple-800 to-purple-800">
		<div
			class="px-4 md:px-10 xl:px-32 w-full flex flex-col md:flex-row justify-between items-center mt-8">
			<!-- Title -->
			<h1
				class="text-4xl sm:text-5xl md:text-5xl text-center md:text-left font-bold text-gray-200">
				PYQ Papers
			</h1>
			<div class="flex mt-6 md:mt-0 sm:gap-2 md:gap-4 items-center">
				<!-- Filter -->
				<div class="group inline-block">
					<button
						class="outline-none focus:outline-none px-3 py-1 text-white rounded-sm flex items-center min-w-32">
						<span class="pr-1 font-semibold flex-1">Filter</span>
						<svg
							class="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20">
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
						</svg>
					</button>
					<ul
						class="border rounded-sm transform scale-0 group-hover:scale-100 absolute transition duration-150 ease-in-out origin-top min-w-32">
						<li class="rounded-sm bg-green-400 px-3 py-1 hover:bg-gray-200">
							Available
						</li>
						<li
							class="rounded-sm bg-white relative px-3 py-1 hover:bg-gray-200">
							<button
								class="w-full text-left flex items-center outline-none focus:outline-none">
								<span class="pr-1 flex-1">Instruments</span>
								<span class="mr-auto">
									<svg
										class="fill-current h-4 w-4 transition duration-150 ease-in-out"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20">
										<path
											d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
									</svg>
								</span>
							</button>
							<ul
								class="border rounded-sm absolute top-0 right-0 transition duration-150 ease-in-out origin-top-left min-w-32">
								<li class="px-3 py-1 hover:bg-gray-200 bg-green-400">
									MiniDrafter
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-green-400">
									Container
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-white">
									French Curve
								</li>
								<li class="px-3 py-1 hover:bg-gray-200 bg-white">Scales</li>
							</ul>
						</li>
					</ul>
				</div>
				<!-- SortBy -->
				<div class="group inline-block">
					<button
						class="outline-none focus:outline-none px-3 py-1 text-white rounded-sm flex items-center min-w-32">
						<span class="font-semibold flex-1">Sort By</span>
						<svg
							class="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-150 ease-in-out"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20">
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
						</svg>
					</button>
					<ul
						class="bg-white border rounded-sm transform scale-0 group-hover:scale-100 absolute transition duration-150 ease-in-out origin-top min-w-32">
						<li class="rounded-sm px-3 py-1 hover:bg-gray-100">Latest</li>
						<li class="rounded-sm px-3 py-1 hover:bg-gray-100">
							Most material
						</li>
					</ul>
				</div>
				<!-- Form -->
				<div>
					<button
						v-on:click="toggleModal()"
						class="px-4 py-4 h-1/2 bg-purple-900 rounded-xl text-xs uppercase font-bold text-white">
						Add More +
					</button>
					<div
						v-if="showModal"
						v-on:click="toggleModal()"
						class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
						<div class="relative my-6 mx-auto max-w-6xl">
							<!--content-->
							<div
								@click.stop="() => {}"
								class="px-8 py-8 w-80 border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
								<!--header-->
								<div
									class="pb-4 flex items-center justify-between border-b border-solid border-slate-200 rounded-t">
									<h3 class="text-xl font-semibold">Add Paper</h3>
									<button
										class="ml-auto bg-transparent border-0 text-black text-xl leading-none font-semibold outline-none focus:outline-none"
										v-on:click="toggleModal()">
										<span
											class="bg-transparent block outline-none focus:outline-none">
											X
										</span>
									</button>
								</div>
								<!--body-->
								<form
									class="space-y-4"
									@submit.prevent="handleSubmit()">
									<input
										v-model="subject"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="text"
										autocomplete="on"
										placeholder="Subject" />
									<div class="flex flex-col justify-center">
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Select Branch
										</h3>
										<select
											v-model="branch"
											class="form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none"
											aria-label="Branches">
											<option
												value="Computer"
												selected>
												Computer
											</option>
											<option value="IT">IT</option>
											<option value="EXTC">EXTC</option>
											<option value="Other">Other</option>
										</select>
									</div>
									<div class="px-2">
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Select Semester
										</h3>
										<div class="flex flex-col w-full justify-center">
											<div class="flex justify-between items-center">
												<div class="flex items-center mr-4">
													<input
														id="1st"
														type="radio"
														v-model="semester"
														value="1st"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="1st"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														1st
													</label>
												</div>
												<div class="flex items-center mr-4">
													<input
														id="2nd"
														type="radio"
														v-model="semester"
														value="2nd"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="2nd"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														2nd
													</label>
												</div>
												<div class="flex items-center mr-4">
													<input
														checked
														id="3rd"
														type="radio"
														v-model="semester"
														value="3rd"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="3rd"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														3rd
													</label>
												</div>
												<div class="flex items-center">
													<input
														id="4th"
														type="radio"
														v-model="semester"
														value="4th"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="4th"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														4th
													</label>
												</div>
											</div>

											<div class="flex justify-between items-center">
												<div class="flex items-center mr-4">
													<input
														id="5th"
														type="radio"
														v-model="semester"
														value="5th"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="5th"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														5th
													</label>
												</div>
												<div class="flex items-center -ml-1 mr-4">
													<input
														id="6th"
														type="radio"
														v-model="semester"
														value="6th"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="6th"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														6th
													</label>
												</div>
												<div class="flex items-center mr-4">
													<input
														checked
														id="7th"
														type="radio"
														v-model="semester"
														value="7th"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="7th"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														7th
													</label>
												</div>
												<div class="flex items-center">
													<input
														id="8th"
														type="radio"
														v-model="semester"
														value="8th"
														name="colored-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="8th"
														class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														8th
													</label>
												</div>
											</div>
										</div>
									</div>
									<input
										v-model="paper"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="url"
										autocomplete="on"
										placeholder="Paper URL" />
									<div
										class="flex items-center justify-between border-t border-solid border-slate-200 rounded-b">
										<button
											class="text-purple-800 bg-transparent border border-solid border-purple-800 hover:bg-purple-800 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-4 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
											type="button"
											v-on:click="toggleModal()">
											Close
										</button>
										<button
											type="submit"
											class="flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
											Submit
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div
						v-if="showModal"
						class="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</div>
			</div>
		</div>
		<div
			v-if="allData.length"
			class="px-4 md:px-10 xl:px-32 pt-12 pb-8 w-full flex flex-wrap justify-center gap-4 items-stretch justify-items-stretch">
			<PaperCard
				v-for="item in allData"
				:key="item.subject"
				:paper="item.paper"
				:branch="item.branch"
				:semester="item.semester"
				:year="Math.ceil(Number(item.semester.substring(0, 1)) / 2)"
				:subject="item.subject" />
		</div>
		<div v-else class="px-4 py-8 w-full flex flex-col items-center justify-center">
			<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
			<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
		</div>
	</div>
</template>

<style scoped>
li > ul {
	transform: translatex(100%) scale(0);
}
li:hover > ul {
	transform: translatex(101%) scale(1);
}
li > button svg {
	transform: rotate(-90deg);
}
li:hover > button svg {
	transform: rotate(-270deg);
}
.group:hover .group-hover\:scale-100 {
	transform: scale(1);
}
.group:hover .group-hover\:-rotate-180 {
	transform: rotate(180deg);
}
.scale-0 {
	transform: scale(0);
}
.min-w-32 {
	min-width: 5rem;
}

body {
	background-color: rgba(31, 41, 55); /* cool gray 800 */
	color: white;
}

.tabAnim {
	z-index: -9;
}

#option0:checked ~ div {
	--tw-translate-x: 0%;
}

#option1:checked ~ div {
	--tw-translate-x: 100%;
}

#option2:checked ~ div {
	--tw-translate-x: 200%;
}

#option3:checked ~ div {
	--tw-translate-x: 300%;
}

#option4:checked ~ div {
	--tw-translate-x: 400%;
}
</style>

<script>
import Vue from 'vue'
import axios from 'axios'
import PaperCard from '@/components/Cards/PaperCard.vue'

export default {
	name: 'PYQPapers',
	components: {
		PaperCard
	},
	data() {
		return {
			branch: '',
			semester: '',
			subject: '',
			paper: '',
			allData: [],
			showModal: false
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		toggleModal: function () {
			this.showModal = !this.showModal
		},
		async loadData() {
			const res = await axios.get('api/papers')
			this.allData = res.data
		},
		async handleSubmit() {
			const data = {
				subject: this.subject,
				branch: this.branch,
				semester: this.semester,
				year: Math.ceil(Number(this.semester.substring(0, 1)) / 2),
				paper: this.paper
			}
			console.log(data)
			const res = await axios.post('api/paper', data)
			this.loadData()
			this.toggleModal()
			Vue.$toast.info(res.data.message, { position: 'top' })
		}
	}
}
</script>
